import { Box, ClickAwayListener, Grid } from '@mui/material';
import { useState } from 'react'
import { calendarData } from '../../../mock-data/Calendar-mock-data';
import "../../../scss/common.scss";
import "./calender.scss";
import GroupDots from "../../../assets/setting/mycompany/invoces/GroupDots.png";
import ActionHeader from '../../../UI/action-header/action-header';
import calendarGroup from "../../../assets/setting/Calendar/calendarGroup.png";
import CalendarViewModal from './calendar-view-modal';
import GlobalCard from '../../../UI/card/GlobalCard';
import DeleteModal from '../departments/delete-modal';
import CalendarTable from './calendar-table';
import { Link } from 'react-router-dom';

const CalendarComp = () => {
  const [editModalShow, setEditModalShow] = useState(false);
  const [selectedId, setSelectedId] = useState('0');
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCalendarTable, setShowCalendarTable] = useState(false);
  return (
    <div>
      {!showCalendarTable &&
        <>
        <Box sx={{ mb: 4 }}>
        <ActionHeader isbuttonRequired={true} buttonName="add new calendar" buttonImg={calendarGroup} heading='Calendars' handleClick={setShowAddModal} />
      </Box>
          <GlobalCard>
            <Grid container className="calender-global-card">
              {calendarData.map((data: any, index: number) => (
                <>
                  <Grid  key={index} item md={2.5} sm={8} xs={12} sx={{ p: 2, m: 2, backgroundColor: "#FFFFFF", display: 'flex', justifyContent: "space-between", borderRadius: "10px", boxShadow: "0px 0px 10px rgba(182, 44, 127, 0.2)" }}>

                    <Box onClick={() => setShowCalendarTable(!showCalendarTable)}>
                      <h4 className='text-color-brown lh-28 fs-20 fw-600'>{data.pkTeamCalendar}</h4>
                      <p className='fs-14 text-color-orange lh-24 fs-16 fw-600'>{data.pakistaniCalendar}</p>
                      <p className='fs-14 text-color-gray lh-28 fs-14 fw-500'> <span>Holidays: </span>{data.holidays}</p>
                      <p className='fs-14 text-color-gray lh-28 fs-14 fw-500'> <span>Weekends: </span>{data.weekends}</p>
                      <p className='fs-14 text-color-gray lh-28 fs-14 fw-500'><span>Working Days: </span>{data.workingDays}</p>
                    </Box>

                    <Box sx={{ position: "relative", marginRight: { md: "10px", xs: "0px" } }} className="br-5" ><img src={GroupDots} className='cursor-pointer' onClick={() => setSelectedId(data.id)} />
                      {/* <Box > */}
                      {selectedId === data.id &&
                        <ClickAwayListener onClickAway={() => setSelectedId("0")}>
                          <Box sx={{ position: "absolute", right: "1px", top: "30px", borderRadius: "5px", background: "#FFFFFF", boxShadow: "0px 0px 0px 4px rgba(247, 136, 18, 0.05);", py: 1, px: 1.5, display: 'flex', flexDirection: "column", justifyContent: "space-between" }}>
                            <p className='cursor-pointer margin-bottom' onClick={() => { setEditModalShow(true); setSelectedId('0') }}>Edit</p>
                            <p className='cursor-pointer margin-bottom' onClick={() => { setEditModalShow(true); setSelectedId('0') }}>Duplicate</p>
                            <p className='cursor-pointer' onClick={() => { setShowDeleteModal(true); setSelectedId('0') }} >Delete</p>
                          </Box>
                        </ClickAwayListener>
                      }
                    </Box>
                  </Grid>

                </>
              ))}
            </Grid>
          </GlobalCard>
          <Box sx={{ paddingLeft: "10px" }}>
            <span className='total-length'>Total: {calendarData.length}</span>
          </Box>
        </>
      }

      {showAddModal && <CalendarViewModal showAddModal={showAddModal} setShowAddModal={setShowAddModal} />}
      <DeleteModal showDeleteModal={showDeleteModal} setShowDeleteModal={setShowDeleteModal} />
      {showCalendarTable &&
        <CalendarTable />
      }
    </div>
  )
}

export default CalendarComp
